exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ml-model-selector {\n  margin-bottom: 16px;\n}\n.ml-model-selector .ml-model-selector-label {\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n.ml-model-selector .ant-select {\n  width: 100%;\n}\n", ""]);

// exports
